module.exports = __webpack_public_path__ + "img/tucan-0.5a7cce52.png";